import React, { Component } from 'react'
import classNames from 'classnames'
import Icon from '../Icon'
import './Banner.css'

export default class Banner extends Component {
  render() {
    const { gray, orange, yellow, icon, children } = this.props

    return (
      <div
        className={classNames('banner', {
          'banner-gray': gray,
          'banner-orange': orange,
          'banner-yellow': yellow,
        })}
      >
        <Icon type={icon} />
        <span className="banner-text">{children}</span>
      </div>
    )
  }
}
